// @ts-nocheck

import { actions as loginActions } from '../../actions/login';
import Client, { isIOSEmbeddedAndStandalone } from '../../client';
import {
  selectUserCC,
  selectUserConnected,
  selectUserJwtToken,
  selectUserSessionId,
} from '../../selectors/user/userPrimary.selector';
import emptyFunc from '../core/emptyFunction';
import { isAndroid, isEmbedded } from '../useragent';

import { nativeEventTypes, onNativeEvent, addNativeEventListener, removeNativeEventListener } from './event';
import requestTypes from './requestTypes';

export { requestTypes, nativeEventTypes };

export const callNative = (...args) => {
  if (isIOSEmbeddedAndStandalone) {
    return require('../bridge/ios').callNative(...args);
  } else if (isAndroid && (isEmbedded || Client.embed)) {
    return require('../bridge/android').callNative(...args);
  } else {
    return null;
  }
};

export const NativeBridge = {
  on: addNativeEventListener,
  off: removeNativeEventListener,
};

export const installBridge = () => {
  if (isIOSEmbeddedAndStandalone) {
    global.callJs = require('../bridge/ios').callJs;
  } else if (isAndroid && (isEmbedded || Client.embed)) {
    global.callJs = require('../bridge/android').callJs;
  } else {
    global.callJs = emptyFunc;
  }

  global.onNativeEvent = onNativeEvent;
};

export default () => installBridge();

const logout = (store) => {
  const state = store.getState();
  const jwt = selectUserJwtToken(state);
  const sessionId = selectUserSessionId(state);
  const cc = selectUserCC(state);
  const isUserConnected = selectUserConnected(state);

  if (isUserConnected) {
    loginActions.doLogout({ jwt, sessionId, cc, disableAuthPlugin: true })(store.dispatch);
  }
};

export const installNativeHandler = (store) => {
  // Evenement logout
  NativeBridge.on('logout', () => logout(store));
};
